"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsClient = void 0;
const client_1 = require("@leid/client");
class PaymentsClient extends client_1.ClientBase {
    async createPayment(request) {
        try {
            const response = await this.httpClient.post('/payments', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createPayment error on a call', request);
        }
    }
    async checkPayment(operationalId, transactionId) {
        try {
            const params = { transactionId };
            const response = await this.httpClient.get(`/payments/${operationalId}/check`, {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'checkPayment error on a call', operationalId, transactionId);
        }
    }
    async getPayments(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/payments', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getPayments error on a call', filter, sortingData);
        }
    }
    async refundPayment(request) {
        try {
            const response = await this.httpClient.post('/payments/refunds', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'refundPayment error on a call', request);
        }
    }
    // Sharing models
    async createSharingModel(sharingModel) {
        try {
            const response = await this.httpClient.post('/sharing-models', sharingModel);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createSharingModel error on a call', sharingModel);
        }
    }
    async getSharingModels(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/sharing-models', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSharingModels error on a call', filter, sortingData);
        }
    }
    async getSharingModel(id) {
        try {
            const response = await this.httpClient.get(`/sharing-models/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSharingModel error on a call', id);
        }
    }
    // Reconciliation
    async createReconciliation(reconciliation) {
        try {
            const response = await this.httpClient.post('/reconciliations', reconciliation);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createReconciliation error on a call', reconciliation);
        }
    }
    async getReconciliations(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/reconciliations', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getReconciliations error on a call', filter, sortingData);
        }
    }
    async getReconciliation(id) {
        try {
            const response = await this.httpClient.get(`/reconciliations/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getReconciliation error on a call', id);
        }
    }
    // Reconciliation Logs
    async getReconciliationLogs(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/reconciliation-logs', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getReconciliationLogs error on a call', filter, sortingData);
        }
    }
    async getReconciliationLog(id) {
        try {
            const response = await this.httpClient.get(`/reconciliation-logs/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getReconciliationLog error on a call', id);
        }
    }
    // License reconciliation
    async getLicenseReconciliations(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/license-reconciliations', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLicenseReconciliations error on a call', filter, sortingData);
        }
    }
    async getLicenseReconciliation(id) {
        try {
            const response = await this.httpClient.get(`/license-reconciliations/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLicenseReconciliation error on a call', id);
        }
    }
    // Pending Reconciliations
    async getPendingReconciliations(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/pending-reconciliations', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getPendingReconciliations error on a call', filter, sortingData);
        }
    }
    async checkPendingReconciliations() {
        try {
            const response = await this.httpClient.get('/pending-reconciliations/check');
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'checkPendingInvoices error on a call');
        }
    }
    // Ledgers
    async createLedger(ledger) {
        try {
            const response = await this.httpClient.post('/ledgers', ledger);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createLedger error on a call', ledger);
        }
    }
    async updateLedger(id, request) {
        try {
            const response = await this.httpClient.put(`/ledgers/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateLedger error on a call', request);
        }
    }
    async getLedgers(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/ledgers', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLedgers error on a call', filter, sortingData);
        }
    }
    async getLedger(id) {
        try {
            const response = await this.httpClient.get(`/ledgers/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLedger error on a call', id);
        }
    }
    // Reports
    async generateReconciliationReport(request) {
        try {
            const response = await this.httpClient.post('/reports/reconciliations', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'generateReconciliationReport error on a call', request);
        }
    }
    async generateLicensesReport(request) {
        try {
            const response = await this.httpClient.post('/reports/licenses', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'generateLicensesReport error on a call', request);
        }
    }
    async sendReconciliationReportToManager(request) {
        try {
            const response = await this.httpClient.post('/reports/reconciliations/emails', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'sendReconciliationReportToManager error on a call', request);
        }
    }
    async sendLicensesReportToManager(request) {
        try {
            const response = await this.httpClient.post('/reports/licenses/emails', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'sendLicensesReportToManager error on a call', request);
        }
    }
    async createDiscountCode(discountCode) {
        try {
            const response = await this.httpClient.post('/discount-codes', discountCode);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createDiscountCode error on call');
        }
    }
    async getDiscountCodes(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/discount-codes', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getDiscountCodes error on a call', filter, sortingData);
        }
    }
    async getDiscountCode(id) {
        try {
            const response = await this.httpClient.get(`/discount-codes/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getDiscountCode error on a call', id);
        }
    }
    async updateDiscountCode(id, discountCode) {
        try {
            const response = await this.httpClient.put(`/discount-codes/${id}`, discountCode);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateDiscountCode error on a call', id, discountCode);
        }
    }
    async deleteDiscountCode(id) {
        try {
            const response = await this.httpClient.delete(`/discount-codes/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteDiscountCode error on a call', id);
        }
    }
    async createDiscountCodeLog(discountCodeLog) {
        try {
            const response = await this.httpClient.post('/discount-codes-logs', discountCodeLog);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createDiscountCodeLog error on call');
        }
    }
    async getDiscountCodeLogs(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/discount-codes-logs', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getDiscountCodeLogs error on a call', filter, sortingData);
        }
    }
    async getDiscountCodeLog(id) {
        try {
            const response = await this.httpClient.get(`/discount-codes-logs/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getDiscountCodeLog error on a call', id);
        }
    }
    async updateDiscountCodeLog(id, discountCodeLog) {
        try {
            const response = await this.httpClient.put(`/discount-codes-logs/${id}`, discountCodeLog);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateDiscountCodeLog error on a call', id, discountCodeLog);
        }
    }
    async deleteDiscountCodeLog(id) {
        try {
            const response = await this.httpClient.delete(`/discount-codes-logs/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteDiscountCode error on a call', id);
        }
    }
    // Heroku payments
    async getHerokuPayments(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/heroku-payments', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getHerokuPayments error on a call', filter, sortingData);
        }
    }
    // Manager Payments
    async getManagerPayments(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/manager-payments', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getManagerPayments error on a call', filter, sortingData);
        }
    }
    // Revenue
    async getTotalRevenueInfo(request) {
        try {
            const response = await this.httpClient.get('/revenues', {
                params: request,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getTotalRevenueInfo error on a call', request);
        }
    }
}
exports.PaymentsClient = PaymentsClient;
